<template>
    <div>
        <div v-if="ready">
            <div v-if="order.id">
                <b-row>
                    <b-col>
                        <orders-order-summary></orders-order-summary>
                    </b-col>
                    <b-col md="8" class="single-order-edit">
                        <orders-edit-order
                            v-if="viewMode === 'edit'"
                        ></orders-edit-order>
                        <orders-view-order
                            v-if="viewMode === 'view'"
                        ></orders-view-order>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import moment from "moment";
import OrdersEditOrder from "./EditOrder";
import calculateCompletedPercentage from "../../plugins/mixins";

export default {
  name: "OrdersSingle",
  components: { OrdersEditOrder },
  mixins: [calculateCompletedPercentage],
  props: {
    orderId: {
      type: String,
      default: ""
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    adminMode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dummySaving: false,
      errorMessage: "",
      successMessage: "",
      showUnlockButton: false
    };
  },
  computed: {
    ...mapState({
      order: state => state.purchaseOrders.order,
      loading: state => state.purchaseOrders.order.loading,
      rowsLoaded: state => state.purchaseOrders.rowsLoaded,
      lastSaveDate: state => state.purchaseOrders.lastSaveDate,
      me: state => state.me.me
    }),
    viewMode() {
      if (this.order.status !== "draft") {
        return "view";
      }

      if (this.me.role.name === "Administrator" || this.me.type === "client") {
        return "edit";
      }

      return "view";
    },
    ready() {
      return this.order.id && this.me.id && this.rowsLoaded;
    }
  },
  mounted() {
    this.getMe();
    this.getRows(this.orderId);
    this.getOrder(this.orderId).then(() => {
      // @todo move to store

      this.setLastSaveDate(
        moment.utc(this.order.updated_at, "YYYY-MM-DD H:m:s").local()
      );
    });
  },
  methods: {
    showSuccess(data) {
      this.successMessage = data.message;
      this.$bvModal.show("modal-success");

      setTimeout(() => {
        window.location.replace("/orders");
      }, 3000);
    },
    showError(data) {
      this.errorMessage = data.message;

      if (data.errorCode == 1) {
        this.showUnlockButton = true;
      } else {
        this.showUnlockButton = false;
      }

      this.$bvModal.show("modal-error");
    },
    unlockPassports() {
      window.open("https://www.ionaute.com/", "_blank");
    },
    reloadPage() {
      location.reload();
    },
    reloadOrder() {
      this.getOrder(this.orderId);
    },
    dummySave() {
      this.dummySaving = true;
      setTimeout(() => {
        this.dummySaving = false;
        // @todo: replace this with this.$router.push('/orders')
        window.location.href = "/orders";
      }, 800);
    },
    ...mapActions({
      getOrder: "purchaseOrders/getOrder",
      getRows: "purchaseOrders/getRows",
      getMe: "me/getMe"
    }),
    ...mapMutations({
      setLastSaveDate: "purchaseOrders/lastSaveDate"
    })
  }
};
</script>

<style>
td.found-product {
  color: #659d74;
}
td.not-found-product {
  color: #a9a9a9;
}
</style>
